/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import swal from "sweetalert";

import { userContext } from '../../../contextProvider/Authentication';
import axiosInstance from '../../../services/AxiosInstance';
import loginbg from '../../../images/login-bg.jpg';
import { Button } from 'react-bootstrap';

const VerifyOtp = () => {

    const { data } = useParams();
    const de_data = JSON.parse(atob(data));

    const history = useHistory();

    const { loginUser } = useContext(userContext);
    const [email, setEmail] = useState('');
    let errorsObj = { email: '', };
    const [errors, setErrors] = useState(errorsObj);
    const [active, setActive] = useState(true);
    const [timeLeft, setTimeLeft] = useState(60);

    useEffect(() => {
        if (!timeLeft) {
            setActive(false);
            return
        };
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeLeft]);

    const resenOtp = () => {
        setTimeLeft(60);
        setActive(true);
        axiosInstance(
            `/user/resend/${de_data.id}/`, {
            method: 'GET',
            headers: {
                'Authorization': ''
            }
        })
        loginUser(de_data?.username, de_data?.password);
    }

    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'OTP is required';
            error = true;
        }
        setErrors(errorObj);
        if (error) {
            return;
        }
        if (email === de_data.otp) {
            axiosInstance(
                'verify-otp/', {
                method: 'POST',
                data: { 'id': de_data?.id },
                headers: {
                    'Authorization': ''
                }
            })
            history.push("/login")
        }
        else {
            swal("", "OTP is not matched", { button: "Try Again!", });
            setEmail('');
        }
    }

    return (
        <div className="page-wraper">
            <div className="page-content bg-white login-style2" style={{ backgroundImage: "url(" + loginbg + ")", backgroundSize: "cover" }}>
                <div className="section-full">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 d-flex">
                                <div className="text-white max-w400 align-self-center">
                                    <h2 className="m-b10">Verify your email</h2>
                                    <p className="m-b30">Verify your email address for further process...</p>
                                    <ul className="list-inline m-a0">
                                        <li><Link to={''} className="m-r10 text-white "><i className="fa fa-facebook"></i></Link></li>
                                        <li><Link to={''} className="m-r10 text-white "><i className="fa fa-google-plus"></i></Link></li>
                                        <li><Link to={''} className="m-r10 text-white "><i className="fa fa-linkedin"></i></Link></li>
                                        <li><Link to={''} className="m-r10 text-white "><i className="fa fa-instagram"></i></Link></li>
                                        <li><Link to={''} className="m-r10 text-white"><i className="fa fa-twitter"></i></Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="login-2 submit-resume p-a30 seth">
                                    <div className="nav">
                                        <form onSubmit={onLogin} className="col-12 p-a0 ">
                                            <p className="font-weight-600">Check your email for OTP</p>
                                            <div className="form-group ">
                                                <label>Enter the OTP *</label>
                                                <div className="input-group">
                                                    <input type="text" className="form-control"
                                                        placeholder="Type Your OTP"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                    {errors.email && <div className="text-danger fs-12">{errors.email}</div>}
                                                </div>
                                            </div>
                                            <div className="text-center">
                                                <button className="site-button float-left">verify</button>
                                                <Button
                                                    className="float-right"
                                                    onClick={() => resenOtp()}
                                                    disabled={active}
                                                    variant="contained"
                                                    title="Click here to Resend OTP"
                                                >Resend OTP
                                                </Button>
                                                <label className="mt-2">{timeLeft} {timeLeft >= 0 && "Seconds Remaining"}</label>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <footer className="login-footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <span className="float-left">© Copyright by <i className="fa fa-heart m-lr5 text-red heart"></i>
                                    <Link to={"#"}>BoscoSoft</Link> </span>
                                <span className="float-right">
                                    All rights reserved.
                                </span>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default VerifyOtp;